import React, { useEffect, useState } from "react";

import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';
import { useNavigate } from "react-router-dom";

import SectionDataPreview from "@app/components/3_modules/dossiers/SectionDataPreview";
import SectionAuthorisation from "@app/components/3_modules/dossiers/SectionAuthorisation";
import Tabs from "@app/components/2_widgets/Tabs";

import { Cloud, ArrowLeft, ChartColumn, FolderOpen } from "lucide-react";
import SectionContract from "@app/components/3_modules/dossiers/SectionContract";
import SectionAddedValue from "@app/components/3_modules/dossiers/SectionAddedValue";
import SectionCspe from "@app/components/3_modules/dossiers/SectionCspe";
import SectionDownload from "@app/components/3_modules/dossiers/SectionDownload";
import { useDossier, useDossierDispatch, DOSSIER_ACTIONS } from "@app/contexts/DossierContext";
import { useCustomer } from "@app/contexts/CustomerContext";

export default function CustomerContent() {
    const dossier = useDossier();

    const [savedAnimation, setSavedAnimation] = useState(false);
    const [activeTab, setActiveTab] = useState(dossier.id);
    
    const auth = useAuth();
    
    const navigate = useNavigate();    
    const customer = useCustomer();
    const dossierDispatch = useDossierDispatch();

    useEffect(() => {
        if (activeTab)
            getDossier(activeTab)
    }, [activeTab])

    function getDossier(dossier_id) {
        apiCall ({
            method: "get",
            path: `/api/v1/dossiers/${dossier_id}`,
            auth: auth,
            onSuccess: (response) => {
                dossierDispatch({
                    type: DOSSIER_ACTIONS.UPDATE_ALL,
                    payload: response.data.dossier
                });
            }
        });
    }

    function displaySavedAnimation() {
        if (savedAnimation) {
            return (
                <div className="saved-animation">
                    <div className="spinner-border"> 
                    </div>
                    Sauvegarde en cours
                </div>
            )
        } else {
            return (
                <div className="saved-animation"><Cloud />Sauvegardé</div>
            )
        }
    }        
    
    function getTabName(dossier) {
        if (dossier.tax_year)
            return (`Bilan ${dossier.tax_year}`)
        else
            return "Nouveau bilan"
    }
    
    const tabs = customer.dossiers.map((dossier) => ({eventKey: dossier.id, tabTitle: getTabName(dossier)}));
    tabs.push({eventKey:"synthesis", tabTitle:"Synthèse", icon: <ChartColumn /> });    

    return (
        <>
            {displaySavedAnimation()}
            <div className="page-title-top">
                <div>
                    <h1 className="title"><ArrowLeft className="clickable" onClick={() => navigate("/")} />Modifier le dossier</h1>
                    <span className="subtitle">{customer.trade_name}</span>
                </div>
            </div> 
            <Tabs
                tabs={tabs}
                onTabChange={setActiveTab}
                activeTab={activeTab}
                displayDossierTabs={true}
            />
            <SectionDataPreview reload={() => setLoaded(false)} />
            <SectionAuthorisation activateSaved={(value) => setSavedAnimation(value)} />
            <SectionContract />
            <SectionAddedValue />
            <SectionCspe />
            <SectionDownload />
        </>
    )
}